import { useState } from "react";
import { IoEyeSharp } from "react-icons/io5";
import { useNavigate} from 'react-router-dom'


const EachAccount =(AccountData)=>{
    const {data,rotatingButtons,index,updateNoOfDaysFunction}=AccountData
    const [isClicked,setIsClicked]=useState(false)
    const [noOfDays,setNoOfDays]=useState(data.noOfDays)
    const navigate = useNavigate();
    const moment = require('moment');

    const updateNoOfDays=(event)=>{
       setNoOfDays(event.target.value)      
    }

    const updateNoOfDaysFunctionHere=()=>{
        if(data.noOfDays===noOfDays){
            setIsClicked(false)
        }else{
            setIsClicked(true)
        }
        const values={
            actual: data.noOfDays,
            changed:noOfDays,
            accountId:data.accountId,
        }
        updateNoOfDaysFunction(values)
    }


    return(
    <><li className="w-full" key={data.id}>
        <div className="flex flex-col min-h-[130px] max-h-fit border m-2 p-2 pl-5 pr-5 hover:shadow-custom-orange text-start font-medium border-[#ff6f61] rounded-lg">
            <div className="flex justify-between" >
                <div className='flex'>
                <div className="">
                    <p className="mr-2 text-gray-800">{index+1}.</p>
                </div>
                <div>
                    <p className="text-gray-800">Account Name: <span className="font-normal text-gray-900 ml-2">{data.accountName!==null?data.accountName:"N/A"}</span></p>   
                    <p className="mb-4 text-gray-800">Official Name: <span className="font-normal ml-2 text-gray-900">{data.officialName!==null?data.officialName:"N/A"}</span> (XXXX <span>{data.mask!==null?data.mask:"N/A"})</span></p>   
                    <p className="text-gray-800">Account Type: <span className="font-normal text-gray-900 ml-2">{data.type!==null?data.type:"N/A"}</span></p>
                    <p className="text-gray-800">Account Sub Type: <span className="font-normal text-gray-900 ml-2">{data.subtype!==null?data.subtype:"N/A"}</span></p>
                </div>
                </div>
                <div className="flex flex-col justify-between items-end">
                    <div className="flex lg:flex-row flex-col">
                        
                        <button onClick={()=>{
                            navigate(`/super-admin/account-transactions/${data.accountId}`)
                        }} className={`text-[#ff6f61] ${rotatingButtons && "hover:shadow-none hover:border-[1px] hover:cursor-not-allowed"} hover:shadow-custom-orange flex justify-center items-center border border-[#ff6f61] rounded-lg hover:border-[2px]`}>
                            <p className="m-1 ml-2 text-sm ">Transactions</p>
                            <p className="m-1 ml-1 mr-2 text-md"><IoEyeSharp /></p>
                        </button>
                    </div>
                    <div className="text-right">
                    <p className="text-gray-800" >Available Balance:  <span className="font-normal text-gray-900 ml-2">${data.availableBalance!==null?data.availableBalance:"N/A"}</span></p>
                    <p className="text-gray-800">Current Balance:  <span className="font-normal text-gray-900 ml-2">${data.currentBalance!==null?data.currentBalance:"N/A"}</span></p>
                    </div>
                </div>
            </div>
            <hr className="mt-2 ml-4"/>
            <div className="flex justify-between items-center mt-3">
                <div className="flex items-center text-gray-800 ml-4">
                    <label className="mr-2">Sync Schedule (Days):</label>
                    <div className="flex hover:border-[1px] border text-gray-900 border-[#ff6f61] focus:border-[#ff6f61] rounded-lg p-1 pt-0 pb-0">
                        <input type="text" value={noOfDays} onChange={updateNoOfDays} className="font-normal focus:outline-none w-10 text-font-normal"/>
                        <button onClick={updateNoOfDaysFunctionHere} className="p-1 pt-0 pb-0 rounded-lg text-sm text-gray-500 hover:text-[#ff6f61] font-normal">{isClicked?"Saving..":"Save"}</button>
                    </div>
                </div>
                <div className="text-gray-800 flex ml-4">
                    <p className="mr-5">Last Sync Date: <span className="font-normal ml-2 text-gray-900 italic">{moment(data.lastSyncDate).format('DD-MM-YYYY (ddd)')}</span></p>
                    <p className="mr-5">Next Sync Date: <span className="font-normal ml-2 text-gray-900 italic">{data.nextSyncDate===null?"N/A":moment(data.nextSyncDate).format('DD-MM-YYYY (ddd)')}</span></p>
                </div>
            </div>
        </div>
    </li></>)
}
export default EachAccount